import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el FÚTBOL FEMENINO RESUELTO después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga de todos los PDFs. El acceso es instantáneo, las 24 horas, desde cualquier dispositivo. En menos de 5 minutos tenés todo en tu celular, tablet o computadora.'
  }, {
    q: '¿Sirve para entrenadores con poca experiencia o solo para los avanzados?',
    a: 'El sistema está diseñado para todos los niveles. Tanto si sos nuevo y querés estructurarte desde el principio, como si ya tenés experiencia y querés sistematizar y profesionalizar tu trabajo. El Tomo 1 empieza desde los fundamentos y el sistema escala hasta el nivel más avanzado.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo para mi plantel?',
    a: 'Los tomos están en formato PDF diseñado. Las plantillas del Bono 3 son editables para que las personalices con los datos de tu equipo. Los contenidos están estructurados para que elijas, adaptes y apliques lo que necesitás según tu contexto real.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en el pack base y en el pack completo. La diferencia del pack completo es que incluye además el Megapack Porteras™ y la Academia del Entrenador™.'
  }, {
    q: '¿Sirve si entreno categorías formativas y también adultas?',
    a: 'Sí. El sistema está diseñado para funcionar en todas las categorías: infantil, juvenil y adulta. El Tomo 2 de planificación incluye adaptaciones específicas por categoría.'
  }, {
    q: '¿Qué diferencia tiene con otros materiales de fútbol femenino?',
    a: 'Es el único sistema integral en español que cubre fisiología femenina, planificación, físico, táctica, sesiones listas, liderazgo y gestión en un solo lugar. No es un curso, no son videos, no son apuntes sueltos. Es un sistema completo, listo para usar desde el primer día, 100% adaptado al contexto argentino.'
  }, {
    q: '¿Por qué elegir el PACK COMPLETO y no el estándar?',
    a: 'El Pack Completo agrega el Megapack Porteras™, el único sistema específico de entrenamiento de arqueras para fútbol femenino en español, y la Academia del Entrenador™ con templates, diagramas, fichas y herramientas de gestión profesional. Si querés tener absolutamente todo resuelto, el pack completo es la opción.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, 100% real. Tenés 7 días para revisar todo el material. Si por cualquier motivo no es lo que esperabas, escribís a nuestro contacto y te devolvemos el dinero completo, sin preguntas, sin formularios, sin demoras.'
  }];
  return <section className="py-10 md:py-20 px-4 bg-gray-50" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <div className="text-center mb-8 md:mb-12" data-id="element-111">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-navy text-white rounded-2xl mb-4 md:mb-6 shadow-lg" data-id="element-112">
            <HelpCircle className="w-6 h-6 md:w-8 md:h-8" data-id="element-113" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-navy mb-2 md:mb-4" data-id="element-114">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-115">
          {faqs.map((faq, index) => <div key={index} className={`bg-white rounded-2xl border transition-all duration-300 ${openIndex === index ? 'border-brandGreen shadow-md' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-116">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-6 py-4 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-117">
                <h3 className={`text-base md:text-lg font-bold pr-4 md:pr-8 ${openIndex === index ? 'text-brandGreen' : 'text-navy'}`} data-id="element-118">
                  {faq.q}
                </h3>
                <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-brandGreen' : 'text-gray-400'}`} data-id="element-119" />
              </button>

              <AnimatePresence data-id="element-120">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-121">
                    <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2" data-id="element-122">
                      <p className="text-sm md:text-base text-gray-600 leading-relaxed font-medium" data-id="element-123">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}